import { usePropertyField } from '../usePropertyField';
import { IApplicationNonRental } from '@apply/api/src/api/ApplyApi';

// ─── NonRental: Construction Budget ──────────────────────────────────────────

export function usePropertyBudgetFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.budget?.handleMode,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                budget: { ...(p.nonRental?.budget ?? {}), handleMode: v },
            } as IApplicationNonRental,
        })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.budget?.uploadedFilename,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                budget: { ...(p.nonRental?.budget ?? {}), uploadedFilename: v },
            } as IApplicationNonRental,
        })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.budget?.uploadedFileApiId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                budget: { ...(p.nonRental?.budget ?? {}), uploadedFileApiId: v },
            } as IApplicationNonRental,
        })
    );
    const [savedFormId, setSavedFormId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.budget?.savedFormId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                budget: { ...(p.nonRental?.budget ?? {}), savedFormId: v },
            } as IApplicationNonRental,
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId, savedFormId, setSavedFormId };
}

// ─── NonRental: Fix/Flip Budget ───────────────────────────────────────────────

export function usePropertyFixFlipBudgetFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.fixFlipBudget?.handleMode,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                fixFlipBudget: { ...(p.nonRental?.fixFlipBudget ?? {}), handleMode: v },
            } as IApplicationNonRental,
        })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.fixFlipBudget?.uploadedFilename,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                fixFlipBudget: { ...(p.nonRental?.fixFlipBudget ?? {}), uploadedFilename: v },
            } as IApplicationNonRental,
        })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.fixFlipBudget?.uploadedFileApiId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                fixFlipBudget: { ...(p.nonRental?.fixFlipBudget ?? {}), uploadedFileApiId: v },
            } as IApplicationNonRental,
        })
    );
    const [savedFormId, setSavedFormId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.fixFlipBudget?.savedFormId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                fixFlipBudget: { ...(p.nonRental?.fixFlipBudget ?? {}), savedFormId: v },
            } as IApplicationNonRental,
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId, savedFormId, setSavedFormId };
}

// ─── NonRental: Land Budget ───────────────────────────────────────────────────

export function usePropertyLandBudgetFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.landBudget?.handleMode,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                landBudget: { ...(p.nonRental?.landBudget ?? {}), handleMode: v },
            } as IApplicationNonRental,
        })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.landBudget?.uploadedFilename,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                landBudget: { ...(p.nonRental?.landBudget ?? {}), uploadedFilename: v },
            } as IApplicationNonRental,
        })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.landBudget?.uploadedFileApiId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                landBudget: { ...(p.nonRental?.landBudget ?? {}), uploadedFileApiId: v },
            } as IApplicationNonRental,
        })
    );
    const [savedFormId, setSavedFormId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.landBudget?.savedFormId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                landBudget: { ...(p.nonRental?.landBudget ?? {}), savedFormId: v },
            } as IApplicationNonRental,
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId, savedFormId, setSavedFormId };
}

// ─── NonRental: Spec Sheet ────────────────────────────────────────────────────

export function usePropertySpecSheetFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.specSheet?.handleMode,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                specSheet: { ...(p.nonRental?.specSheet ?? {}), handleMode: v },
            } as IApplicationNonRental,
        })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.specSheet?.uploadedFilename,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                specSheet: { ...(p.nonRental?.specSheet ?? {}), uploadedFilename: v },
            } as IApplicationNonRental,
        })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.specSheet?.uploadedFileApiId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                specSheet: { ...(p.nonRental?.specSheet ?? {}), uploadedFileApiId: v },
            } as IApplicationNonRental,
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId };
}

// ─── NonRental: Plans ─────────────────────────────────────────────────────────

export function usePropertyPlansFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.plans?.handleMode,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                plans: { ...(p.nonRental?.plans ?? {}), handleMode: v },
            } as IApplicationNonRental,
        })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.plans?.uploadedFilename,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                plans: { ...(p.nonRental?.plans ?? {}), uploadedFilename: v },
            } as IApplicationNonRental,
        })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.plans?.uploadedFileApiId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                plans: { ...(p.nonRental?.plans ?? {}), uploadedFileApiId: v },
            } as IApplicationNonRental,
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId };
}

// ─── NonRental: Survey ────────────────────────────────────────────────────────

export function usePropertySurveyFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.survey?.handleMode,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                survey: { ...(p.nonRental?.survey ?? {}), handleMode: v },
            } as IApplicationNonRental,
        })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.survey?.uploadedFilename,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                survey: { ...(p.nonRental?.survey ?? {}), uploadedFilename: v },
            } as IApplicationNonRental,
        })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.survey?.uploadedFileApiId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                survey: { ...(p.nonRental?.survey ?? {}), uploadedFileApiId: v },
            } as IApplicationNonRental,
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId };
}

// ─── NonRental: General Contractor Resume ─────────────────────────────────────

export function usePropertyGcResumeFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.generalContractorResume?.handleMode,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                generalContractorResume: { ...(p.nonRental?.generalContractorResume ?? {}), handleMode: v },
            } as IApplicationNonRental,
        })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.generalContractorResume?.uploadedFilename,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                generalContractorResume: { ...(p.nonRental?.generalContractorResume ?? {}), uploadedFilename: v },
            } as IApplicationNonRental,
        })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.generalContractorResume?.uploadedFileApiId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                generalContractorResume: { ...(p.nonRental?.generalContractorResume ?? {}), uploadedFileApiId: v },
            } as IApplicationNonRental,
        })
    );
    const [gcData, setGcData] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.generalContractorResume?.data,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                generalContractorResume: { ...(p.nonRental?.generalContractorResume ?? {}), data: v },
            } as IApplicationNonRental,
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId, gcData, setGcData };
}

// ─── NonRental: Pre-Sale Contract ─────────────────────────────────────────────

export function usePropertyPresaleContractFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.presaleContract?.handleMode,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                presaleContract: { ...(p.nonRental?.presaleContract ?? {}), handleMode: v },
            } as IApplicationNonRental,
        })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.presaleContract?.uploadedFilename,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                presaleContract: { ...(p.nonRental?.presaleContract ?? {}), uploadedFilename: v },
            } as IApplicationNonRental,
        })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.presaleContract?.uploadedFileApiId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                presaleContract: { ...(p.nonRental?.presaleContract ?? {}), uploadedFileApiId: v },
            } as IApplicationNonRental,
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId };
}

// ─── NonRental: Proof of Occupancy ────────────────────────────────────────────────────────

export function usePropertyProofOfOccupancyFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.proofOfOccupancy?.handleMode,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                proofOfOccupancy: { ...(p.nonRental?.proofOfOccupancy ?? {}), handleMode: v },
            } as IApplicationNonRental,
        })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.proofOfOccupancy?.uploadedFilename,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                proofOfOccupancy: { ...(p.nonRental?.proofOfOccupancy ?? {}), uploadedFilename: v },
            } as IApplicationNonRental,
        })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.proofOfOccupancy?.uploadedFileApiId,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                proofOfOccupancy: { ...(p.nonRental?.proofOfOccupancy ?? {}), uploadedFileApiId: v },
            } as IApplicationNonRental,
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId };
}
